import debugFn from 'debug';
import React, { useEffect, useRef } from 'react';
import videojs from 'video.js';
import Player from 'video.js/dist/types/player';

interface Props {
  options?: any;
  onReady?: (player: Player) => void;
}

const debug = debugFn('video-js');

export const VideoJSNoContext = ({ options, onReady }: Props) => {
  const playerRef = React.useRef<Player | null>(null);
  const videoRef = useRef<HTMLDivElement>(null);

  const finalOptions = {
    autoplay: false,
    volume: 1,
    controls: false,
    fluid: true,
    ...options,
  };

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement('video-js');
      videoRef.current?.appendChild(videoElement);

      debug(`initialize videojs player`);
      playerRef.current = videojs(videoElement, finalOptions, function (this: Player) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const player = this;

        if (options.autoplay) {
          player.play();
        }

        onReady && onReady(player);
      } as any);
    }
  }, [videoRef]);

  // dispose when the component unmounts
  useEffect(() => {
    debug(`set player ref`);
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        debug(`unmount, dispose player`);
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div style={{ maxWidth: '100%' }} data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};
